export default "__VITE_ASSET__CGhmg2U9__"